import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import { useState } from "react";
import VariantDescription from "@/src-refactor/modules/shared/components/variant-description/VariantDescription";
import { IconButton, styled } from "@mui/material";
import SpainIcon from "@icons-rf/flags/spain-icon.svg?react";
import UniteState from "@icons-rf/flags/unite-state-icon.svg?react";

type idiom = "es" | "en";
const DescriptionContent = () => {
  const {
    PROPERTY_DETAIL: { principalData }
  } = useRealEstateDetailContext();
  const [idiom, setIdiom] = useState<idiom>("es"); // ['es', 'en']

  const handleChangeIdiom = (value: idiom) => {
    setIdiom(value);
  };

  if (!principalData.description) return <Container></Container>;

  return (
    <Container>
      <TitleAndSelect>
        <div>
          <TextSimple color="blue" size="title" font="gotham" weight="bold">
            Descripción
          </TextSimple>
        </div>

        <ContainerCountries>
          <IconButtonSelected
            onClick={() => handleChangeIdiom("es")}
            selected={idiom == "es"}
          >
            <SpainIcon />
          </IconButtonSelected>
          {principalData.eng_description && (
            <IconButtonSelected
              onClick={() => handleChangeIdiom("en")}
              selected={idiom == "en"}
            >
              <UniteState />
            </IconButtonSelected>
          )}
        </ContainerCountries>
      </TitleAndSelect>

      <VariantDescription
        text={
          idiom === "es"
            ? principalData.description
            : principalData.eng_description ?? ""
        }
        show="126px"
      />
    </Container>
  );
};

export default DescriptionContent;

const Container = styled("div")({
  marginTop: "20px",
  marginBottom: "12px"
});

const TitleAndSelect = styled("div")({
  display: "flex",
  gap: "10px",
  alignItems: "center"
});

const ContainerCountries = styled("div")({
  display: "flex"
});

const IconButtonSelected = styled(IconButton)<{ selected: boolean }>(
  ({ selected }) => ({
    border: selected ? "2px solid var(--m-color-blue-03)" : "none",
    padding: "1px",
    margin: "0 7px",
    boxSizing: "border-box",
    "& svg": {
      width: "20px",
      height: "20px"
    }
  })
);
